import { render } from "./Widget1.vue?vue&type=template&id=7fb35ead"
import script from "./Widget1.vue?vue&type=script&lang=ts"
export * from "./Widget1.vue?vue&type=script&lang=ts"
script.render = render

export default script